'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, HTMLAttributes } from 'react';
import Image from '@/components/Image';
import Link from '@/components/Link';
import { CaseStudyItem } from '@/components/ModalProvider/MenuNavigationModal/types';
import { Typography } from '@/components/shared/Typography';
import VimeoPlayer from '@/components/shared/VimeoPlayer';
import StrapiRichContent from '@/components/StrapiRichContent';
import cn from '@/helpers/cn';
import useDevice from '@/hooks/useDevice';
import css from './style.module.scss';
interface Props extends HTMLAttributes<HTMLAnchorElement> {
  data: CaseStudyItem;
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
}
const CaseStudyCard: FC<Props> = t0 => {
  const $ = _c(33);
  let data;
  let onClick;
  let onMouseEnter;
  let onMouseLeave;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      data,
      className: t1,
      onMouseEnter,
      onMouseLeave,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = data;
    $[2] = onClick;
    $[3] = onMouseEnter;
    $[4] = onMouseLeave;
    $[5] = rest;
    $[6] = t1;
  } else {
    data = $[1];
    onClick = $[2];
    onMouseEnter = $[3];
    onMouseLeave = $[4];
    rest = $[5];
    t1 = $[6];
  }
  const className = t1 === undefined ? "" : t1;
  const device = useDevice();
  const t2 = data?.url || "";
  let t3;
  if ($[7] !== className) {
    t3 = cn(css.caseStudy, className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== className || $[10] !== data.image || $[11] !== data.title || $[12] !== data.videoThumbnailUrl || $[13] !== data.videoUrl) {
    t4 = <div className={css.caseImageWrap}>{data?.videoUrl ? <VimeoPlayer fitCover={true} url={data.videoUrl} thumbnailUrl={data.videoThumbnailUrl || undefined} className={cn(css.caseImage, className)} /> : <Image className={cn(css.caseImage, className)} width={800} height={600} src={data.image || ""} alt={String(data.title) || ""} />}</div>;
    $[9] = className;
    $[10] = data.image;
    $[11] = data.title;
    $[12] = data.videoThumbnailUrl;
    $[13] = data.videoUrl;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = device === "desktop" ? "h6" : "body-l";
  let t6;
  if ($[15] !== data.title || $[16] !== t5) {
    t6 = <Typography className={css.caseTitle} tag="h3" variant={t5}>{data.title}</Typography>;
    $[15] = data.title;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== data.description || $[19] !== device) {
    t7 = data.description ? <Typography className={css.caseDescription} tag="div" variant={device === "desktop" ? "body-m" : "body-s"}><StrapiRichContent content={data.description} /></Typography> : null;
    $[18] = data.description;
    $[19] = device;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <div className={css.caseContent}>{t6}{t7}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== onClick || $[25] !== onMouseEnter || $[26] !== onMouseLeave || $[27] !== rest || $[28] !== t2 || $[29] !== t3 || $[30] !== t4 || $[31] !== t8) {
    t9 = <Link href={t2} className={t3} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick} {...rest}>{t4}{t8}</Link>;
    $[24] = onClick;
    $[25] = onMouseEnter;
    $[26] = onMouseLeave;
    $[27] = rest;
    $[28] = t2;
    $[29] = t3;
    $[30] = t4;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
};
export default CaseStudyCard;